import { define, type, auto } from 'type-r';
import Collection, {Record} from './base'
import OrderItem, { OrderItemCollection } from './order_item'
@define
export class SubscriptionCollection<R extends Subscription = Subscription> extends Collection<R> {
}

@define
export default class Subscription extends Record {
    static Collection = SubscriptionCollection
    @type(String).as weekRange: string
    @type(OrderItemCollection).as orderItems : OrderItemCollection;
    @type(String).as cutoffAlert: string
}
